import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import {
  EUIFRConnections,
  GetFRConfigurations, GetFRConfigurationsSuccess,
  UpdateFRConfiguration, UpdateFRConfigurationSuccess,

} from '../actions/fr-actions';
import { FRServices } from '../../../core/connect-forms-recognizer.service';
import { of, empty } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService } from 'bz-genome-angular';

//import {MessageService} from '../../services/message.service';

@Injectable()
export class FREffects {
  UpdateFRConfigurationEffect = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateFRConfiguration>(EUIFRConnections.UpdateFRConfiguration),
      switchMap((action) => this.frServices.updateConfiguration(action.payload, action.guid)),
      switchMap((response: any) => {
        if (typeof response === 'boolean') {
          this.showSuccessToast();
          return of(new UpdateFRConfigurationSuccess(true));
        }
        else {
          this.showErrorToast(response.errorReason);
          //this.messageService.showError(response.errorReason);
          return empty();
        }
      })
    )
  );
  GetFRConfigurationsEffect = createEffect(() =>
    this.actions$.pipe(
      ofType<GetFRConfigurations>(EUIFRConnections.GetFRConfigurations),
      switchMap((action) => this.frServices.getConfigurations()),
      switchMap((response: any) => {
        if (Array.isArray(response))
          return of(new GetFRConfigurationsSuccess(response));
        else {
          //this.messageService.showError(response.errorReason);
          return empty();
        }
      })
    )
  );

  constructor(private actions$: Actions, private frServices: FRServices, private _toastService: BzgToastService,
    private _translateService: TranslateService) {
  }

  private showSuccessToast() {
    this._translateService.get('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY').subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type: 'success',
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
    });
  }

  private showErrorToast(message: string) {

    this._toastService.open(
      message,
      {
        type: 'error',
        duration: 0,
        verticalPosition: 'top',
        horizontalPosition: 'right'
      });
  }


}





/*
.pipe(
  catchError(err => {
    return 'ERROR'
  })
)
  .switchMap((results) => {
    if (results === 'ERROR')
      return 'ERROR';
    return of(results);
  })*/
